export class NavigationView {
    constructor() {
        this._viewStack = [];
    }
    get viewDepth() {
        return this._viewStack.length;
    }
    get currentElement() {
        return this._viewStack[this._viewStack.length - 1];
    }
    setStageRenderer(view, renderer) {
        this.controlledStage = view;
        this.renderer = renderer;
        this.controlledStage.removeChildren(0, this.controlledStage.children.length);
    }
    setDefaultElement(element) {
        if (this._viewStack.length == 0) {
            this.controlledStage.addChild(element);
            this._viewStack.push(element);
        }
        else {
            this._viewStack.splice(0, 1, element);
        }
    }
    show(element) {
        if (this._viewStack.length > 0) {
            this.controlledStage.removeChild(this.currentElement);
        }
        this._viewStack.push(element);
        this.controlledStage.addChild(this.currentElement);
    }
    back() {
        if (this._viewStack.length <= 1) {
            throw new Error("Cannot bring view stack below 1 element.");
        }
        this.controlledStage.removeChild(this.currentElement);
        let removed = this._viewStack.pop();
        removed.destroy();
        this.controlledStage.addChild(this.currentElement);
        this.currentElement.resize(this.renderer.width, this.renderer.height);
    }
    passWheelEvent(event, canvasX, canvasY) {
        if (this.currentElement != undefined) {
            this.currentElement.mouseWheelHandler(event, canvasX, canvasY);
        }
    }
}
const navigationView = new NavigationView();
export { navigationView };
//# sourceMappingURL=NavigationView.js.map